// const baseSize = 32
function setRem () {
    // const scale = document.documentElement.clientWidth / 750
    // document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px'
}
setRem()
window.onresize = function () {
    setRem()
}



// WEBPACK FOOTER //
// ./src/assets/js/base/rem.js